import React, { useState } from "react";
import { collection, query, where, getDocs, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";


const FriendSearch = () => {
    const { currentUser } = useAuth();
    const [searchTerm, setSearchTerm] = useState("");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const handleSearch = async () => {
        setLoading(true);
        setMessage("");
        setResults([]);
        if (!searchTerm.trim()) {
            setLoading(false);
            return;
        }
        try {
            // Поиск пользователей по displayName (точный поиск, можно улучшить)
            const q = query(
                collection(db, "users"),
                where("displayName", ">=", searchTerm),
                where("displayName", "<=", searchTerm + "\uf8ff")
            );
            const snapshot = await getDocs(q);
            const users = snapshot.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .filter(user => user.id !== currentUser.uid); // исключаем себя
            if (users.length === 0) {
                setMessage("Пользователи не найдены");
            }
            setResults(users);
        } catch (error) {
            setMessage("Ошибка поиска: " + error.message);
        }
        setLoading(false);
    };

    const handleSendRequest = async (toUserId) => {
        try {
            // Создаём заявку в коллекции friendRequests
            await addDoc(collection(db, "friendRequests"), {
                fromUserId: currentUser.uid,
                toUserId,
                status: "pending",
                createdAt: serverTimestamp(),
            });
            setMessage("Заявка отправлена");
        } catch (error) {
            setMessage("Ошибка при отправке заявки: " + error.message);
        }
    };

    return (
        <div style={{ maxWidth: "1000px", margin: "0 auto", textAlign: "center" }}>
            <h1 className="dateText">Поиск друзей</h1>
            <input
                type="text"
                placeholder="Введите имя пользователя"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                    width: "80%",
                    maxWidth: "500px",
                    padding: "8px 12px",
                    marginBottom: "10px",
                    borderRadius: "4px",
                    border: "1px solid var(--neon-cyan)",
                    background: "rgba(0,0,0,0.5)"
                }}
            />
            <div style={{ marginBottom: "20px" }}>
                <button
                    onClick={handleSearch}
                    disabled={loading}
                >
                    {loading ? "Поиск..." : "Найти"}
                </button>
            </div>
            {message && <p style={{ color: "var(--neon-pink)" }}>{message}</p>}

            <ul style={{ listStyle: "none", padding: 0 }}>
                {results.map(user => (
                    <li key={user.id} style={{
                        marginBottom: "15px",
                        padding: "10px",
                        background: "rgba(30,30,30,0.7)",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <strong style={{ color: "var(--neon-cyan)" }}>{user.displayName || "Аноним"}</strong>
                        <button
                            onClick={() => handleSendRequest(user.id)}
                            style={{
                                padding: "6px 12px",
                                background: "var(--neon-pink)",
                                color: "#000",
                                border: "none",
                                borderRadius: "4px",
                                fontWeight: "bold",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                                boxShadow: "0 0 8px rgba(255, 0, 255, 0.5)"
                            }}
                        >
                            Добавить в друзья
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default FriendSearch;
